'use client';
/* External Imports */
import {
  Box,
  Flex,
  Modal,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import dynamic from 'next/dynamic';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
/**
 *
 */
const YouTubeComponent = ({ item, backgroundStyle }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const BannerModal = dynamic(() =>
    import('@app-ps/Components/Banners/BannerModal')
  );
  // const textColorBase = backgroundStyle === 'amber' ? 'black' : '#F1EDE9';

  return (
    <Box
      position="relative"
      _hover={{ '.textBox': { display: 'block' } }}
      height={{ '2xl': '312px', lg: '247.5px', md: '312px', base: 'auto' }}
      maxW={{ lg: '370.46px', '2xl': '468px' }}
      width="100%"
    >
      <Box
        cursor="pointer"
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        zIndex="1"
        onClick={onOpen}
      >
        <Flex
          justify="center"
          align="center"
          width="100%"
          height="100%"
          objectFit={'cover'}
        >
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1720495733-button-play.png`}
            height={'70px'}
            width={'70px'}
            alt="Play button"
          />
        </Flex>
      </Box>
      <LazyLoadImageComponent
        src={item.thumbnailImage.url}
        alt={item.thumbnailImage.alt}
        height={{ md: '100%', base: 'auto' }}
        width="100%"
        objectFit="cover"
      />

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={{ base: 'full', md: '6xl' }}
        isCentered
        h={{ base: '295px', md: 'auto' }}
      >
        <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
        <BannerModal
          sectionContent={{ videoUrl: item.videoUrl.url }}
          onClose={onClose}
        />
      </Modal>
    </Box>
  );
};

export default YouTubeComponent;
